import React from 'react'
import { Dialog } from '@headlessui/react';
import { useEffect,useState } from 'react';
import { IKImage } from 'imagekitio-react';
import { unstable_HistoryRouter as HistoryRouter, useLocation, useNavigate, useParams } from 'react-router-dom';
import { checkUserAccess, logout } from '../../redux/actions/authentication';
import { useDispatch,useSelector } from 'react-redux';
import { useRef } from 'react';
import { SET_PREV_PAGE, SET_USER_ACCESS } from '../../redux/actions/types';
import { SET_IS_ACTIVATION } from '../../redux/actions/types';
import { useCookies } from 'react-cookie';


const UserAccess = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user_id = useSelector(
      (store) => store?.profileDetails?.user_coins_data?.[0]?.user_id
    );
  
    const [ removeCookie ] = useCookies();

   useEffect(()=>{


    return (()=>{
      dispatch({type : SET_PREV_PAGE, payload : location.pathname});
    })
   },[location.pathname])
 
  
   function logoutHandler() {
    dispatch(logout());
    removeCookie("authToken", { path: "/" });
    navigate("/courses");
}

    useEffect(()=>{

          if(user_id ===0 || user_id === null || user_id === undefined|| location.pathname ==='/onboarding' || location.pathname === '/login' || location.pathname === '/verification' || location.pathname === '/pricing' || location.pathname === '/onboarding/loader' || location.pathname === '/onboarding/questions/1' || location.pathname === '/onboarding/questions/2' || location.pathname === '/onboarding/questions/3' || location.pathname === '/onboarding/questions/4' || location.pathname === '/onboarding/questions/4' || location.pathname === '/onboarding/questions/5' || location.pathname === '/onboarding/questions/6' || location.pathname === '/onboarding/questions/7' || location.pathname === '/onboarding/analysis')
          {
            //do nothing
            
          }
          else{
            console.log('something')
           dispatch(checkUserAccess((successObj)=>{
            dispatch({type : SET_USER_ACCESS , payload : successObj})
            if(successObj?.is_archived === true){
              logoutHandler();
            }
          else if(successObj?.is_onboarded === false){
              navigate('/onboarding')
            }
           else if(successObj?.['user_access_state'] === 'trial_blocked'){
              navigate('/pricing')
            }

            else if(successObj?.is_activated === false){
              dispatch({type : SET_IS_ACTIVATION , payload : true})
              const myArray = (location.pathname).split("/");
              console.log('split' , myArray)
              if(myArray?.length >=3 && `${successObj?.first_lesson?.skill_slug}` === myArray?.[2]){
                //do nothing
              }
              else{
              navigate(`/${successObj?.first_lesson?.course_slug}/${successObj?.first_lesson?.skill_slug}/${successObj?.first_lesson?.mskill_slug}/${successObj?.first_lesson?.id}`)
              }
            }
            else if(successObj?.is_activated === true){
              dispatch({type : SET_IS_ACTIVATION , payload : false})
            }

           }, (err)=>{}))  
        //setIsModalActive(true);
        }
        
    },[location.pathname,user_id]);


    return <></>;
}
export default UserAccess;